(() => {
  const init = root => {
    root.querySelectorAll('[data-innes-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const slides = [...gallery.querySelectorAll('[data-innes-slide]')];
      const thumbs = [...gallery.querySelectorAll('[data-innes-thumb]')];
      const counter = gallery.querySelector('[data-innes-count]');
      const dialog = gallery.querySelector('dialog');
      const full = gallery.querySelector('[data-innes-full]');
      let index = 0;
      const select = n => {
        if (!slides.length) return;
        index = (n + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.hidden = i !== index;
          if (i !== index) slide.querySelectorAll('video').forEach(video => video.pause());
        });
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
        if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
      };
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => select(i)));
      gallery.querySelector('[data-innes-prev]')?.addEventListener('click', () => select(index - 1));
      gallery.querySelector('[data-innes-next]')?.addEventListener('click', () => select(index + 1));
      gallery.querySelectorAll('[data-innes-zoom]').forEach(button => button.addEventListener('click', () => {
        full.src = button.dataset.original;
        full.alt = button.querySelector('img')?.alt || '';
        dialog.showModal();
      }));
      gallery.querySelector('[data-innes-close]')?.addEventListener('click', () => dialog.close());
      dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      document.addEventListener('variant:change', event => {
        const id = event.detail?.variant?.featured_media?.id;
        const found = slides.findIndex(slide => String(slide.dataset.mediaId) === String(id));
        if (found >= 0) select(found);
      });
    });
    root.querySelectorAll('[data-product-history-id]').forEach(node => window.webvista?.addProductToHistory(node.dataset.productHistoryId));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
